/* tslint:disable */
/* eslint-disable */
/**
 * Apperta Physical Health REST API
 * Apperta Physical Health REST API
 *
 * The version of the OpenAPI document: 0.2.0-SNAPSHOT2
 * Contact: info@staircase13.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Represents a pathway template list item
 * @export
 * @interface PathwayTemplateItemDto
 */
export interface PathwayTemplateItemDto {
    /**
     * Id
     * @type {string}
     * @memberof PathwayTemplateItemDto
     */
    id: string;
    /**
     * The template name
     * @type {string}
     * @memberof PathwayTemplateItemDto
     */
    name: string;
    /**
     * The template description
     * @type {string}
     * @memberof PathwayTemplateItemDto
     */
    description?: string;
    /**
     * The template summary
     * @type {string}
     * @memberof PathwayTemplateItemDto
     */
    summary: string;
    /**
     * Prepopulated fields
     * @type {Array<string>}
     * @memberof PathwayTemplateItemDto
     */
    prepopulatedFields?: Array<string>;
}

/**
 * Check if a given object implements the PathwayTemplateItemDto interface.
 */
export function instanceOfPathwayTemplateItemDto(value: object): value is PathwayTemplateItemDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('summary' in value) || value['summary'] === undefined) return false;
    return true;
}

export function PathwayTemplateItemDtoFromJSON(json: any): PathwayTemplateItemDto {
    return PathwayTemplateItemDtoFromJSONTyped(json, false);
}

export function PathwayTemplateItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PathwayTemplateItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'summary': json['summary'],
        'prepopulatedFields': json['prepopulatedFields'] == null ? undefined : json['prepopulatedFields'],
    };
}

export function PathwayTemplateItemDtoToJSON(value?: PathwayTemplateItemDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'summary': value['summary'],
        'prepopulatedFields': value['prepopulatedFields'],
    };
}

